/**
 * Localization file for Finnish - Finland (fi-FI)
 */
import * as kv from "knockout.validation";

if (!kv || typeof kv.defineLocale !== "function") {
    throw new Error("Knockout-Validation is required, please ensure it is loaded before this localization file");
}

kv.defineLocale("fi-FI", {
    required: "Pakollinen kenttä.",
    min: "Arvon on oltava suurempi tai yhtä suuri kuin {0}.",
    max: "Arvon on oltava pienempi tai yhtä suuri kuin {0}.",
    minLength: "Syötä vähintään {0} merkkiä.",
    maxLength: "Enintään {0} merkkiä sallittu.",
    pattern: "Tarkista arvo.",
    step: "Lukemaa on kasvatettava arvolla {0}.",
    email: "Virheellinen sähköpostiosoite.",
    date: "Virheellinen päivämäärä.",
    dateISO: "Virheellinen päivämäärä.",
    number: "Anna numeroarvo.",
    digit: "Vain numerot sallittu.",
    phoneUS: "Virheellinen puhelinnumero.",
    equal: "Arvojen on oltava samat.",
    notEqual: "Arvot eivät saa olla samat.",
    unique: "Arvon on oltava yksilöllinen."
});
